<template>
  <calendar-main
    :get-events="getEvents"
    :get-categories="getCategories"
    :add-permission="hasAddPermission"
    :edit-permission="hasEditPermission"
    :delete-permission="hasDeletePermission"
    @delete-event="handleDelete"
  />
</template>

<script>
import { CalendarMain } from "operations";
import _service from "@/modules/operation-calendar-event/api.js";
import applications from "@/utils/constants/applications.js";

export default {
  name: "MainEventWrapper",
  components: { CalendarMain },
  computed: {
    hasAddPermission() {
      return this.$store.getters.HasPermission("calendar.add");
    },
    hasEditPermission() {
      return this.$store.getters.HasPermission("calendar.edit");
    },
    hasDeletePermission() {
      return this.$store.getters.HasPermission("calendar.delete");
    },
  },
  methods: {
    getEvents(categoryId) {
      return _service.fetchEvents(categoryId, applications.Mipe);
    },
    getCategories() {
      return _service.fetchCategory();
    },
    async handleDelete(eventId) {
      await _service.deleteEvent(eventId);
      location.reload();
    }
  },
};
</script>
